// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiGoogle as RawSiGoogle } from "react-icons/si";
export const SiGoogle = /* @__PURE__ */ createIcon(RawSiGoogle, "SiGoogle", 0);
